import { Component, inject } from '@angular/core';
import { MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { imageAssets } from '@core/constants/themes';
import { NewSaleDialogComponent } from '../new-sale-dialog/new-sale-dialog.component';
import { IceButtonComponent } from '@app/shared/components/atoms/ice-button/ice-button.component';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-gtin-info-dialog',
  templateUrl: './gtin-info-dialog.component.html',
  styleUrls: ['./gtin-info-dialog.component.scss'],
  imports: [CdkScrollable, MatDialogContent, MatDialogActions, IceButtonComponent],
})
export class GtinInfoDialogComponent {
  dialogRef = inject<MatDialogRef<NewSaleDialogComponent>>(MatDialogRef);

  imageAssets = imageAssets;
}
